<div class="w-100">
    <!-- ****************** CARD NUMBER ****************** -->
    <div class="bold-label-text">Numéro de la carte *</div>
    <div class="w-100" id="card-number"></div>
    <mat-error class="input-error" id="invalid_number"></mat-error>
    <!-- ****************** EXPIRY ****************** -->
    <div class="bold-label-text mt-3">Date d'expiration *</div>
    <div class="w-100" id="card-expiry"></div>
    <mat-error class="input-error" id="invalid_expiry_year_past"></mat-error>
    <!-- ****************** CVC ****************** -->
    <div class="bold-label-text mt-3">Cryptogramme *</div>
    <div class="w-100" id="card-cvc"></div>
    <mat-error class="input-error" id="incomplete_cvc"></mat-error>
</div>
<div class="w-100 mt-3 cta_container text-center">
    @if (cancelButtonExcludedProcedure().indexOf(paymentDetailsInterface.procedureCode) == -1 && !location.path().includes('mon-compte')) {
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
    }
    <button type="submit" class="cta_btn level_2 column" (click)="pay(true)">Payer<span></span></button>
</div>